<template>
    <div>
        <div>
            <b-row no-gutters>
                <b-col>
                    <DStoreNav></DStoreNav>
                </b-col>
            </b-row>
        </div>
        <div>
            <div class="estore-body">
                <div class="estore-content store-vouchers-tab">
                    <PageToolbar />
                    <DataTable />
                    <NewVoucher :status="modal.new.status" />
                    <EditVoucher :status="modal.edit.status" />
                    <ConfirmDelete :status="modal.delete.status" />
                    <ViewStoreVouchers :status="modal.storeVouchers.status" />
                    <CSVErrors :status="modal.csvErrors.status" />
                    <Pagination />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DStoreNav from "./DStoreNav.vue";
import { mapState } from "vuex";
import PageToolbar from "@/views/dstore/store-vouchers/PageToolbar";
import DataTable from "@/views/dstore/store-vouchers/DataTable";
import NewVoucher from "@/views/dstore/store-vouchers/NewVoucher";
import EditVoucher from "@/views/dstore/store-vouchers/EditVoucher";
import ConfirmDelete from "@/views/dstore/store-vouchers/ConfirmDelete";
import CSVErrors from "@/views/dstore/store-vouchers/CSVErrors";
import ViewStoreVouchers from "@/views/dstore/store-vouchers/ViewStoreVouchers";
import Pagination from "@/views/dstore/store-vouchers/Pagination";

export default {
    name: "store-vouchers",
    computed: {
        ...mapState("estoreVouchers", ["modal"])
    },
    data() {
        return {
            searchPayload: null
        };
    },
    components: {
        DStoreNav,
        PageToolbar,
        DataTable,
        NewVoucher,
        CSVErrors,
        EditVoucher,
        ConfirmDelete,
        ViewStoreVouchers,
        Pagination
    },
    methods: {}
};
</script>
